import React from 'react'

import { TableHeader } from './TableHeader'
import { TableSorter, TableColumnConfig } from './types'
import {
  TableHeaders as TableHeadersElement,
  TableRow as TableRowElement,
} from '@/Atomic/Templates/Table'

interface TableHeadersProps {
  sorter?: TableSorter
  isReorderingColumnsActive: boolean
  sortColumn?: (accessor: string) => void
  columns: TableColumnConfig[]
  selectAllRows?: (select?: boolean) => void
  isAllRowsSelected?: () => boolean | undefined
  isAllRowsSelectDisabled?: () => boolean
}

export const TableHeaders: React.FC<TableHeadersProps> = ({
  columns,
  sorter,
  sortColumn,
  isReorderingColumnsActive,
  selectAllRows,
  isAllRowsSelected,
  isAllRowsSelectDisabled,
}) => {
  return (
    <TableHeadersElement>
      <TableRowElement>
        {columns.map((headerElement) => {
          return (
            <TableHeader
              key={headerElement.accessor}
              {...headerElement}
              sorter={sorter}
              sortColumn={sortColumn}
              isReorderingColumnsActive={isReorderingColumnsActive}
              selectAllRows={selectAllRows}
              isAllRowsSelected={isAllRowsSelected}
              isAllRowsSelectDisabled={isAllRowsSelectDisabled}
            />
          )
        })}
      </TableRowElement>
    </TableHeadersElement>
  )
}
